export default function (adminURL, instance) {
  return {
    signIn: (payload) => instance.post(adminURL + "auth/signin", payload),
    signOut: () => instance.get(adminURL + "auth/signout"),
  };
}
